
import { writable,derived } from "svelte/store";
export const annioBase2 = writable('2026');
export const annioGrafica = writable('2021');
export const paisBase2 = writable('1');
export const entidadBase2 = writable('');
export const municipioBase2 = writable('');
export const sensorBase2 = writable('modis')
export const pcFiltroBase2 = writable('pcalor')
export const mapInterval = writable('3')
export const mapIntervaltipo = writable('3')
export const getPaisTot2 = writable([])
export const getEntTot2 = writable([])
export const getMunTot2 = writable([])
export const getPaisTotAnp2 = writable([])
export const getEntTotAnp2 = writable([])
export const getMunTotAnp2 = writable([])
export const getPaisTotForestal2 = writable([])
export const getEntTotForestal2 = writable([])
export const getMunTotForestal2 = writable([])
export const panelInfo2 = writable({});
export const storyStatus=writable({
    filter:false
});
export const refPaisImg=writable([
    { id:1,name:'México',img:'flag_mexico'},
    { id:2,name:'Estados Unidos',img:'flag_usa'},
    { id:3,name:'Guatemala',img:'flag_guatemala'},
    { id:4,name:'Belice',img:'flag_belize'},
    { id:5,name:'Honduras',img:'flag_honduras'},
    { id:6,name:'El Salvador',img:'flag_elsalvador'},
    { id:7,name:'Nicaragua',img:'flag_nicaragua'},
    { id:8,name:'Costa Rica',img:'flag_costa_rica'},
    { id:9,name:'Panáma',img:'flag_panama'}
]);
